module.exports = __webpack_public_path__ + "static/media/process_3.5d66f9fa.png";